import { useEffect, useState } from "react";
import { LatLng } from "types/map";
import {
  getTimezoneFallbackCenter,
  GPS_DEFAULT_ZOOM,
  TIMEZONE_DEFAULT_ZOOM,
} from "libraries/mapDefaultCenter";

type ReturnType = {
  center: LatLng;
  zoom: number;
};

/**
 * Default map framing: current GPS when allowed, otherwise browser timezone region.
 */
const useMapDefaultCenter = (): ReturnType => {
  const [center, setCenter] = useState<LatLng>(() =>
    getTimezoneFallbackCenter()
  );
  const [zoom, setZoom] = useState(TIMEZONE_DEFAULT_ZOOM);

  useEffect(() => {
    if (!navigator.geolocation) {
      console.warn(
        "[useMapDefaultCenter] Geolocation unavailable — using timezone center"
      );
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position: GeolocationPosition) => {
        setCenter({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setZoom(GPS_DEFAULT_ZOOM);
      },
      () => {
        console.warn(
          "[useMapDefaultCenter] Geolocation refused — using timezone center"
        );
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 60000 }
    );
  }, []);

  return { center, zoom };
};

export default useMapDefaultCenter;
